import { api } from "./BackendService";

export const getById = (id) => api.get(`/cp/collaborators/${id}`);
export const create = (data) => api.post(`/cp/collaborators`, data);
export const update = (id, data) => api.put(`/cp/collaborators/${id}`, data);
export const list = (page) =>
  api.get("/cp/collaborators", { params: { page } });
export const accessMobile = (id) => api.put(`/cp/collaborators/${id}`);
